interface PodcastEmbedProps {
  url: string;
  title?: string;
  platform: 'spotify' | 'apple' | 'custom';
}

export function PodcastEmbed({ url, title, platform: _platform }: PodcastEmbedProps) {
  if (!url) {
    return (
      <div className="h-[152px] w-full bg-gray-200 rounded-lg flex items-center justify-center">
        <p className="text-gray-500">No podcast URL provided</p>
      </div>
    );
  }

  return (
    <div className="mb-8 overflow-hidden rounded-xl border border-gray-100 bg-white shadow-sm">
      <iframe
        src={url}
        className="h-[152px] w-full"
        allowFullScreen
        allow="clipboard-write; encrypted-media; fullscreen; picture-in-picture;"
        title={title || "Podcast player"}
      />
    </div>
  );
}
